import { render, staticRenderFns } from "./VehicleClassCodeSelector.vue?vue&type=template&id=478db23a"
import script from "./VehicleClassCodeSelector.vue?vue&type=script&lang=js"
export * from "./VehicleClassCodeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports